export const EXPERIMENTS = {
  PREMIER_SAVING_CAPTURE_EMAIL: 'deposit_capture_email_pse'
};

export const EXPERIMENT_OPTS = {
  PREMIER_SAVING_CAPTURE_EMAIL: {
    Control: 'hide_email_capture',
    VariantA: 'show_email_capture'
  }
};
